<div class="col w100 grow-1">
    <div class="w100 align-start justify-start">
        <rr-start-logo color="inverse" routerLink="/"></rr-start-logo>
    </div>
    <div class="grow-1 w100 h100 col align-center justify-center">
        <div>Connecting to System...</div>
    </div>
</div>
<rr-spinner *ngIf="!hidespinner"></rr-spinner>
